import { Skeleton } from "@sagot/ui";

const STARTER_ROWS = 4;
const AUDIENCE_ROWS = 4;
const STAGE_ROWS = 5;
const ACTION_ROWS = 3;

function Rows({ count, className }: { count: number; className: string }) {
  return (
    <div className="space-y-2">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} className={className} />
      ))}
    </div>
  );
}

/** Placeholder for the "Assistant name" control while a template's setup loads. */
export function NameSkeleton() {
  return (
    <div>
      <Skeleton className="mb-1.5 h-4 w-28" />
      <Skeleton className="h-10" />
    </div>
  );
}

/** Same sections and heights as `DraftFields`, shown while the template switcher loads a new draft. */
export function EditorSkeleton() {
  return (
    <div className="space-y-6" aria-hidden="true" data-testid="editor-skeleton">
      <div>
        <Skeleton className="mb-1.5 h-4 w-32" />
        <Skeleton className="h-44" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-36" />
        <Rows count={STARTER_ROWS} className="h-10" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-24" />
        <Rows count={AUDIENCE_ROWS} className="h-10" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-28" />
        <Rows count={STAGE_ROWS} className="h-10" />
      </div>
      <div className="space-y-2">
        <Skeleton className="h-4 w-20" />
        <Rows count={ACTION_ROWS} className="h-12 rounded-lg" />
      </div>
      <div>
        <Skeleton className="mb-1.5 h-4 w-36" />
        <Skeleton className="h-10" />
      </div>
      <div>
        <Skeleton className="mb-1.5 h-4 w-32" />
        <Skeleton className="h-20" />
      </div>
    </div>
  );
}
